import {
    createAccordionComponent,
    IAccordionItemProperties,
    IAccordionProperties,
} from '@vfde-brix/accordion';
import { OFFER_CARD_PRICE_DETAILS, OFFER_CARD_PRICE_DETAILS_CONTENT } from 'Container/OfferDisplay/constant';
import { IOfferFromJSON } from '../../../../types';
import { handleAccordionChangeEvent } from '../eventHelper';

const HTMLMarkup = require('../../_html_/AccordionContent.hbs');

/**
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 * FIND STRUCTURE OF PRICE DETAILS IN readme.md
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 */

/**
 * A C C O R D I O N
 */
const renderAccordionContent = (element: HTMLElement) => {

    const accordionContentDIV: HTMLElement = <HTMLElement> element.getElementsByClassName(OFFER_CARD_PRICE_DETAILS_CONTENT)[0];

    accordionContentDIV.innerHTML = HTMLMarkup();
};

const renderAccordionElement = (offer: IOfferFromJSON, element: HTMLElement, accordionOpenAction) => {

    const accordionDIV: HTMLElement = <HTMLElement> element.getElementsByClassName(OFFER_CARD_PRICE_DETAILS)[0];
    const accordionItemProperties: IAccordionItemProperties[] = [{
        stdId: `accordion-item-offer-${offer.ID}`,
        stdHeadline: 'Wie setzt sich der Preis zusammen?',
        optOpen: false,
        containerAnyComponent: `<div class="${OFFER_CARD_PRICE_DETAILS_CONTENT}"></div>`,
    }];

    const accordionProperties: IAccordionProperties = {
        spacing: '0',
        items: accordionItemProperties,
        business: {
            onToggle: (item) => {
                handleAccordionChangeEvent(item, accordionOpenAction);
            },
        },
    };

    createAccordionComponent(accordionDIV, accordionProperties);

};

/**
 * renders the multi divider dynamically
 * @param element
 * @param offer
 */
export const renderAccordion = (element: HTMLElement, offer: IOfferFromJSON, accordionOpenAction) => {

    // Creates Brix Component Accordion
    renderAccordionElement(offer, element, accordionOpenAction);

    // adds Content to Accordion Item
    renderAccordionContent(element);

};
